/**
 * Texts for Animations page
 * 
 * VIDEO URL FORMATS SUPPORTED:
 * 1. YouTube URLs:
 *    - https://www.youtube.com/watch?v=VIDEO_ID
 *    - https://youtu.be/VIDEO_ID
 *    - https://www.youtube.com/embed/VIDEO_ID
 * 
 * 2. Local video files:
 *    - /video/filename.mp4
 *    - Relative or absolute paths to MP4 files
 * 
 * Simply edit the 'videoUrl' field in each video object below.
 * The system automatically detects YouTube links and displays them accordingly.
 */
export const animationsPageText = {
    title: 'Animações - CamAPS FX',
    titleMeta: 'Animações CamAPS FX - Guias visuais passo a passo',
    descriptionMeta: 'Assista a animações curtas concebidas para responder a algumas das perguntas mais frequentes da CamDiab sobre a utilização da aplicação CamAPS FX.',
    keywords:
        'animações camaps fx, tutoriais camaps, tutoriais aplicação diabetes, animações bomba de insulina, tutoriais cgm, guias em vídeo',
    localeMeta: 'pt_PT',

    mainHeader: 'Animações',
    mainSubHeader: 'Estas animações curtas foram concebidas para responder a algumas das perguntas mais frequentes da CamDiab.',

    filterAll: 'Todos',
    filterYpsoPump: 'YpsoPump',
    filterDana: 'Dana',
    sortNewest: 'Mais recentes',
    sortOldest: 'Mais antigos',
    sortAZ: 'A-Z',
    sortPopular: 'Mais populares',

    // Getting Started Section
    gettingStartedHeader: 'Pronto para começar?',
    step1Title: '<strong>Passo 1:</strong> Descarregue a aplicação',
    step2Title: '<strong>Passo 2:</strong> Crie uma conta',
    step3Title: '<strong>Passo 3:</strong> Inicie a formação essencial na aplicação',
    step4Title: '<strong>Passo 4:</strong> Emparelhe a bomba e o CGM escolhidos (com a aprovação da sua equipa de diabetes) ou explore a aplicação com o <strong>Modo virtual</strong>',
    virtualModeTooltipText: 'O Modo virtual permite-lhe experimentar a aplicação sem estar ligado a uma bomba de insulina e a um sensor CGM reais.',
    
    // Support Section
    supportSectionTitle: 'Precisa de ajuda para instalar a aplicação?',
    supportSectionText: 'Visite a nossa secção de apoio para obter orientações.',
    supportButtonText: ' APOIO',

    // Additional Resources Section
    additionalResourcesTitle: 'Recursos adicionais',
    additionalResourcesSubtitle: 'Explore outras formas de aprender sobre o CamAPS FX',
    
    userTrainingTitle: 'Formação para utilizadores',
    userTrainingDescription: 'Materiais de formação abrangentes para o ajudar a começar a utilizar o CamAPS FX.',
    userTrainingLink: '/user-training',
    
    webinarsTitle: 'Webinars',
    webinarsDescription: 'Participe nos nossos webinars em direto e sessões gravadas para saber mais.',
    webinarsLink: '#',
    
    factsheetsTitle: 'Fichas informativas',
    factsheetsDescription: 'Descarregue fichas informativas e guias úteis para referência rápida.',
    factsheetsLink: '#',

    videos: [
        // {
        //     id: 1,
        //     title: 'Getting Started with YpsoPump',
        //     description: 'Learn how to set up your YpsoPump with CamAPS FX.',
        //     date: '15 Dec 2024',
        //     duration: '5:24',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_1 with actual video ID from @camdiab channel
        //     views: 5420
        // },
        // {
        //     id: 2,
        //     title: 'Dana Pump Setup Guide',
        //     description: 'Step-by-step guide for Dana pump configuration.',
        //     date: '10 Dec 2024',
        //     duration: '7:15',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'dana',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_2 with actual video ID from @camdiab channel
        //     views: 8950
        // },
        // {
        //     id: 3,
        //     title: 'Understanding Your CGM Data',
        //     description: 'Learn how to interpret your glucose readings.',
        //     date: '5 Dec 2024',
        //     duration: '4:33',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'all',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_3 with actual video ID from @camdiab channel
        //     views: 12340
        // },
        // {
        //     id: 4,
        //     title: 'YpsoPump Advanced Features',
        //     description: 'Explore advanced settings and customization.',
        //     date: '1 Dec 2024',
        //     duration: '6:48',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_4 with actual video ID from @camdiab channel
        //     views: 3210
        // },
        // {
        //     id: 5,
        //     title: 'Dana Pump Troubleshooting',
        //     description: 'Common issues and solutions for Dana pump.',
        //     date: '28 Nov 2024',
        //     duration: '5:12',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'dana',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_5 with actual video ID from @camdiab channel
        //     views: 6780
        // },
        // {
        //     id: 6,
        //     title: 'Managing Meal Boluses',
        //     description: 'Best practices for meal-time insulin delivery.',
        //     date: '25 Nov 2024',
        //     duration: '8:05',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'all',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_6 with actual video ID from @camdiab channel
        //     views: 9450
        // },
        // {
        //     id: 7,
        //     title: 'YpsoPump Battery Management',
        //     description: 'Tips for extending battery life and replacement.',
        //     date: '20 Nov 2024',
        //     duration: '3:27',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_7 with actual video ID from @camdiab channel
        //     views: 4120
        // },
        // {
        //     id: 8,
        //     title: 'Dana Pump Cartridge Change',
        //     description: 'How to safely change your insulin cartridge.',
        //     date: '15 Nov 2024',
        //     duration: '4:55',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'dana',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_8 with actual video ID from @camdiab channel
        //     views: 7230
        // },
        // {
        //     id: 9,
        //     title: 'Exercise Mode Setup',
        //     description: 'Configure settings for physical activity.',
        //     date: '10 Nov 2024',
        //     duration: '6:18',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'all',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_9 with actual video ID from @camdiab channel
        //     views: 10560
        // },
        // {
        //     id: 10,
        //     title: 'YpsoPump Alerts & Notifications',
        //     description: 'Customize your pump alerts and alarms.',
        //     date: '5 Nov 2024',
        //     duration: '5:41',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_10 with actual video ID from @camdiab channel
        //     views: 5890
        // },
        // {
        //     id: 11,
        //     title: 'Dana Pump Connectivity',
        //     description: 'Bluetooth pairing and connection tips.',
        //     date: '1 Nov 2024',
        //     duration: '7:52',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'dana',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_11 with actual video ID from @camdiab channel
        //     views: 8120
        // },
        // {
        //     id: 12,
        //     title: 'Night Time Settings',
        //     description: 'Optimize your settings for better sleep.',
        //     date: "18 Apr 2016",
        //     duration: '6:03',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'all',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_12 with actual video ID from @camdiab channel
        //     views: 11230
        // }
        {
            "id": 1,
            "title": "Modo virtual",
            "description": "Modo virtual",
            "date": "15 Dec 2025",
            "duration": "1:30",
            "category": "all",
            "videoUrl": "https://youtu.be/PUXDc5nXcaU",
            "views": 500
        },
        {
            "id": 2,
            "title": "Viajar com o CamAPS FX",
            "description": "Viajar com o CamAPS FX",
            "date": "12 Dec 2025",
            "duration": "2:49",
            "category": "YpsoPump ",
            "videoUrl": "https://youtu.be/unUO7daCp3c",
            "views": 31000
        },
        {
            "id": 3,
            "title": "Viajar com o CamAPS FX",
            "description": "Viajar com o CamAPS FX",
            "date": "12 Dec 2025",
            "duration": "2:50",
            "category": "Dana ",
            "videoUrl": "https://youtu.be/GplwuTfOGv8",
            "views": 30900
        },
        {
            "id": 4,
            "title": "Compreender hiperglicemias e hipoglicemias",
            "description": "Compreender hiperglicemias e hipoglicemias",
            "date": "12 Dec 2025",
            "duration": "4:55",
            "category": "dana",
            "videoUrl": "https://youtu.be/mR_wO0BM9mM",
            "views": 29900
        },
        {
            "id": 5,
            "title": "Compreender hiperglicemias e hipoglicemias (mmol/L)",
            "description": "Compreender hiperglicemias e hipoglicemias (mmol/L)",
            "date": "12 Dec 2025",
            "duration": "4:55",
            "category": "YpsoPump ",
            "videoUrl": "https://youtu.be/Y0dhj7hvXgM",
            "views": 30000
        },
        {
            "id": 6,
            "title": "Compreender hiperglicemias e hipoglicemias (mg/dL)",
            "description": "Compreender hiperglicemias e hipoglicemias (mg/dL)",
            "date": "12 Dec 2025",
            "duration": "4:55",
            "category": "YpsoPump ",
            "videoUrl": "https://youtu.be/rr6oytHLT74",
            "views": 29000
        },
        {
            "id": 7,
            "title": "MealAssist do CamAPS FX",
            "description": "MealAssist do CamAPS FX",
            "date": "3 Dec 2025",
            "duration": "1:36",
            "category": "all",
            "videoUrl": "https://youtu.be/On-YDive00w",
            "views": 400
        },
        {
            "id": 8,
            "title": "Utilizar o CamAPS FX na gravidez",
            "description": "Utilizar o CamAPS FX na gravidez",
            "date": "17 Feb 2026",
            "duration": "6:41",
            "category": "dana",
            "videoUrl": "https://youtu.be/DrGDN-0iwrA",
            "views": 32900
        },
        {
            "id": 9,
            "title": "Utilizar o CamAPS FX na gravidez (mg/dL)",
            "description": "Utilizar o CamAPS FX na gravidez (mg/dL)",
            "date": "17 Feb 2026",
            "duration": "6:47",
            "category": "ypso",
            "videoUrl": "https://youtu.be/AM4MBXNtsSQ",
            "views": 32000
        },
        {
            "id": 10,
            "title": "Utilizar o CamAPS FX na gravidez (mmol/L)",
            "description": "Utilizar o CamAPS FX na gravidez (mmol/L)",
            "date": "17 Feb 2026",
            "duration": "6:42",
            "category": "ypso",
            "videoUrl": "https://youtu.be/F0CwAzxgOps",
            "views": 33000
        },
        {
            "id": 11,
            "title": "Peso corporal",
            "description": "Peso corporal",
            "date": "17 Feb 2026",
            "duration": "1:10",
            "category": "dana",
            "videoUrl": "https://youtu.be/MPL14Y6f4QI",
            "views": 23900
        },
        {
            "id": 12,
            "title": "Peso corporal",
            "description": "Peso corporal",
            "date": "17 Feb 2026",
            "duration": "1:10",
            "category": "ypso",
            "videoUrl": "https://youtu.be/JIVtrzBmQ2w",
            "views": 24000
        },
        {
            "id": 13,
            "title": "Dose diária total (TDD)",
            "description": "Dose diária total (TDD)",
            "date": "17 Feb 2026",
            "duration": "1:13",
            "category": "dana",
            "videoUrl": "https://youtu.be/2cFsVmXuJSk",
            "views": 22900
        },
        {
            "id": 14,
            "title": "Dose diária total (TDD)",
            "description": "Dose diária total (TDD)",
            "date": "17 Feb 2026",
            "duration": "1:13",
            "category": "ypso",
            "videoUrl": "https://youtu.be/yxz0nnAhM5E",
            "views": 23000
        },
        {
            "id": 15,
            "title": "CamAPS Companion",
            "description": "CamAPS Companion",
            "date": "8 Sep 2025",
            "duration": "2:50",
            "category": "ypso",
            "videoUrl": "https://youtu.be/L3Vla5ktT_o",
            "views": 6000
        },
        {
            "id": 16,
            "title": "CamAPS Companion",
            "description": "CamAPS Companion",
            "date": "3 May 2024",
            "duration": "3:36",
            "category": "dana",
            "videoUrl": "https://youtu.be/tV8I5Bnnsqg",
            "views": 5900
        },
        {
            "id": 17,
            "title": "Partilha de dados da diabetes - aplicação iOS",
            "description": "Partilha de dados da diabetes - aplicação iOS",
            "date": "11 Aug 2026",
            "duration": "2:13",
            "category": "ypso",
            "videoUrl": "https://youtu.be/MrpZg-oOHdw",
            "views": 7000
        },
        {
            "id": 18,
            "title": "Partilha de dados da diabetes - aplicação Android",
            "description": "Partilha de dados da diabetes - aplicação Android",
            "date": "11 Aug 2026",
            "duration": "2:48",
            "category": "ypso",
            "videoUrl": "https://youtu.be/-48aU7X7iTs",
            "views": 8000
        },
        {
            "id": 19,
            "title": "Partilha de dados da diabetes",
            "description": "Partilha de dados da diabetes",
            "date": "11 Aug 2026",
            "duration": "2:35",
            "category": "dana",
            "videoUrl": "https://youtu.be/g8RQDWyf7gU",
            "views": 7900
        },
        {
            "id": 20,
            "title": "O que é um impulso de permeabilidade? (mg/dL)",
            "description": "O que é um impulso de permeabilidade? (mg/dL)",
            "date": "20 May 2025",
            "duration": "2:55",
            "category": "ypso",
            "videoUrl": "https://youtu.be/EhOrwkhINT8",
            "views": 300
        },
        {
            "id": 21,
            "title": "O que é um impulso de permeabilidade? (mmol/L)",
            "description": "O que é um impulso de permeabilidade? (mmol/L)",
            "date": "20 May 2025",
            "duration": "2:57",
            "category": "ypso",
            "videoUrl": "https://youtu.be/0JHBcLS1QOU",
            "views": 200
        },
        {
            "id": 22,
            "title": "Utilizar o Ease-off",
            "description": "Utilizar o Ease-off",
            "date": "11 Aug 2026",
            "duration": "3:21",
            "category": "ypso",
            "videoUrl": "https://youtu.be/ec3I0eMbtN8",
            "views": 15000
        },
        {
            "id": 23,
            "title": "Utilizar o Ease-off",
            "description": "Utilizar o Ease-off",
            "date": "11 Aug 2026",
            "duration": "3:20",
            "category": "dana",
            "videoUrl": "https://youtu.be/s6jKDLdfsDg",
            "views": 14900
        },
        {
            "id": 24,
            "title": "Utilizar o Boost",
            "description": "Utilizar o Boost",
            "date": "11 Aug 2026",
            "duration": "2:01",
            "category": "ypso",
            "videoUrl": "https://youtu.be/c3SkU7tI4rM",
            "views": 14000
        },
        {
            "id": 25,
            "title": "Utilizar o Boost",
            "description": "Utilizar o Boost",
            "date": "11 Aug 2026",
            "duration": "2:01",
            "category": "dana",
            "videoUrl": "https://youtu.be/ITaLBOMjghE",
            "views": 13900
        },
        {
            "id": 26,
            "title": "Utilizar o Block",
            "description": "Utilizar o Block",
            "date": "11 Aug 2026",
            "duration": "1:15",
            "category": "ypso",
            "videoUrl": "https://youtu.be/AK0tcsZ7uRQ",
            "views": 5000
        },
        {
            "id": 27,
            "title": "Utilizar o Block",
            "description": "Utilizar o Block",
            "date": "11 Aug 2026",
            "duration": "1:15",
            "category": "dana",
            "videoUrl": "https://youtu.be/UkAghv_IgzU",
            "views": 4900
        },
        {
            "id": 28,
            "title": "Utilizar o Auto mode",
            "description": "Utilizar o Auto mode",
            "date": "11 Aug 2026",
            "duration": "2:45",
            "category": "ypso",
            "videoUrl": "https://youtu.be/2eEgIGqClMw",
            "views": 18000
        },
        {
            "id": 29,
            "title": "Utilizar o Auto mode",
            "description": "Utilizar o Auto mode",
            "date": "15 Feb 2024",
            "duration": "2:03",
            "category": "dana",
            "videoUrl": "https://youtu.be/KcWwqxb45-I",
            "views": 17900
        },
        {
            "id": 30,
            "title": "Utilizar o Add meal",
            "description": "Utilizar o Add meal",
            "date": "11 Aug 2026",
            "duration": "3:48",
            "category": "ypso",
            "videoUrl": "https://youtu.be/Lewch4s4gCc",
            "views": 16000
        },
        {
            "id": 31,
            "title": "Utilizar o Add meal",
            "description": "Utilizar o Add meal",
            "date": "11 Aug 2026",
            "duration": "3:49",
            "category": "dana",
            "videoUrl": "https://youtu.be/oZt4an1pJNo",
            "views": 15900
        },
        {
            "id": 32,
            "title": "Principais dicas técnicas - aplicação iOS",
            "description": "Principais dicas técnicas - aplicação iOS",
            "date": "20 May 2025",
            "duration": "3:18",
            "category": "ypso",
            "videoUrl": "https://youtu.be/0gFg2eIHhFw",
            "views": 27000
        },
        {
            "id": 33,
            "title": "Principais dicas técnicas - aplicação Android",
            "description": "Principais dicas técnicas - aplicação Android",
            "date": "20 May 2025",
            "duration": "3:21",
            "category": "ypso",
            "videoUrl": "https://youtu.be/CTmkjItioRs",
            "views": 28000
        },
        {
            "id": 34,
            "title": "Principais dicas técnicas",
            "description": "Principais dicas técnicas",
            "date": "28 Nov 2023",
            "duration": "3:14",
            "category": "dana",
            "videoUrl": "https://youtu.be/lP9jKnyA0Gw",
            "views": 27900
        },
        {
            "id": 35,
            "title": "Definir o objetivo pessoal de glicose (mmol/L)",
            "description": "Definir o objetivo pessoal de glicose (mmol/L)",
            "date": "11 Aug 2026",
            "duration": "2:18",
            "category": "ypso",
            "videoUrl": "https://youtu.be/N7--wjRfbwk",
            "views": 20000
        },
        {
            "id": 36,
            "title": "Definir o objetivo pessoal de glicose",
            "description": "Definir o objetivo pessoal de glicose",
            "date": "11 Aug 2026",
            "duration": "2:18",
            "category": "dana",
            "videoUrl": "https://youtu.be/BQDqupWSWSA",
            "views": 19900
        },
        {
            "id": 37,
            "title": "Definir o objetivo pessoal de glicose (mg/dL)",
            "description": "Definir o objetivo pessoal de glicose (mg/dL)",
            "date": "11 Aug 2026",
            "duration": "2:19",
            "category": "ypso",
            "videoUrl": "https://youtu.be/feg6MPG9PDo",
            "views": 19000
        },
        {
            "id": 38,
            "title": "Configurar o calculador de bólus (mmol/L)",
            "description": "Configurar o calculador de bólus (mmol/L)",
            "date": "11 Aug 2026",
            "duration": "3:49",
            "category": "ypso",
            "videoUrl": "https://youtu.be/Gf3mJhjwG6c",
            "views": 22000
        },
        {
            "id": 39,
            "title": "Configurar o calculador de bólus (mg/dL)",
            "description": "Configurar o calculador de bólus (mg/dL)",
            "date": "17 Feb 2026",
            "duration": "3:44",
            "category": "ypso",
            "videoUrl": "https://youtu.be/KfROo8PfoQc",
            "views": 21000
        },
        {
            "id": 40,
            "title": "Configurar o calculador de bólus",
            "description": "Configurar o calculador de bólus",
            "date": "17 Feb 2026",
            "duration": "2:34",
            "category": "dana",
            "videoUrl": "https://youtu.be/HhwVwm9nlPU",
            "views": 21900
        },
        {
            "id": 41,
            "title": "Definir alertas - aplicação iOS (mg/dL)",
            "description": "Definir alertas - aplicação iOS (mg/dL)",
            "date": "20 May 2025",
            "duration": "2:33",
            "category": "ypso",
            "videoUrl": "https://youtu.be/--kZle0n5G8",
            "views": 9000
        },
        {
            "id": 42,
            "title": "Definir alertas - aplicação iOS (mmol/L)",
            "description": "Definir alertas - aplicação iOS (mmol/L)",
            "date": "11 Aug 2026",
            "duration": "2:32",
            "category": "ypso",
            "videoUrl": "https://youtu.be/lRIkMubOVNU",
            "views": 10000
        },
        {
            "id": 43,
            "title": "Definir alertas - aplicação Android (mg/dL)",
            "description": "Definir alertas - aplicação Android (mg/dL)",
            "date": "20 May 2025",
            "duration": "2:35",
            "category": "ypso",
            "videoUrl": "https://youtu.be/FGBIJeYlGb0",
            "views": 11000
        },
        {
            "id": 44,
            "title": "Definir alertas - aplicação Android (mmol/L)",
            "description": "Definir alertas - aplicação Android (mmol/L)",
            "date": "11 Aug 2026",
            "duration": "2:32",
            "category": "ypso",
            "videoUrl": "https://youtu.be/AlquHy_xMUE",
            "views": 12000
        },
        {
            "id": 45,
            "title": "Definir alertas",
            "description": "Definir alertas",
            "date": "11 Aug 2026",
            "duration": "2:32",
            "category": "dana",
            "videoUrl": "https://youtu.be/aNgXOi-mowQ",
            "views": 8900
        },
        {
            "id": 46,
            "title": "Emparelhar a bomba e o sensor",
            "description": "Emparelhar a bomba e o sensor",
            "date": "17 Feb 2026",
            "duration": "1:36",
            "category": "ypso",
            "videoUrl": "https://youtu.be/u2qDc7I7ZXg",
            "views": 25000
        },
        {
            "id": 47,
            "title": "Emparelhar a bomba e o sensor",
            "description": "Emparelhar a bomba e o sensor",
            "date": "17 Feb 2026",
            "duration": "1:30",
            "category": "dana",
            "videoUrl": "https://youtu.be/FpJ9ys5w4jY",
            "views": 24900
        },
        {
            "id": 48,
            "title": "Navegar na aplicação",
            "description": "Navegar na aplicação",
            "date": "11 Aug 2026",
            "duration": "2:55",
            "category": "ypso",
            "videoUrl": "https://youtu.be/gCcZmyxNZHw",
            "views": 26000
        },
        {
            "id": 49,
            "title": "Navegar na aplicação",
            "description": "Navegar na aplicação",
            "date": "11 Aug 2026",
            "duration": "2:55",
            "category": "dana",
            "videoUrl": "https://youtu.be/BLqIjeBe2RQ",
            "views": 25900
        },
        {
            "id": 50,
            "title": "Administrar um bólus de refeição",
            "description": "Administrar um bólus de refeição",
            "date": "11 Aug 2026",
            "duration": "1:01",
            "category": "ypso",
            "videoUrl": "https://youtu.be/RVxdqCmhlfI",
            "views": 17000
        },
        {
            "id": 51,
            "title": "Administrar um bólus de refeição",
            "description": "Administrar um bólus de refeição",
            "date": "11 Aug 2026",
            "duration": "1:00",
            "category": "dana",
            "videoUrl": "https://youtu.be/DYZSkWynlTY",
            "views": 16900
        },
        {
            "id": 52,
            "title": "Administrar uma correção manual",
            "description": "Administrar uma correção manual",
            "date": "11 Aug 2026",
            "duration": "1:45",
            "category": "ypso",
            "videoUrl": "https://youtu.be/S--bwTb-jII",
            "views": 13000
        },
        {
            "id": 53,
            "title": "Administrar uma correção manual",
            "description": "Administrar uma correção manual",
            "date": "11 Aug 2026",
            "duration": "1:45",
            "category": "dana",
            "videoUrl": "https://youtu.be/HNYN8kIdsPI",
            "views": 12900
        },
        {
            "id": 54,
            "title": "Alterar as unidades de hidratos de carbono",
            "description": "Alterar as unidades de hidratos de carbono",
            "date": "20 May 2025",
            "duration": "0:52",
            "category": "ypso",
            "videoUrl": "https://youtu.be/K0LrmfdIHpE",
            "views": 2000
        },
        {
            "id": 55,
            "title": "Alterar as unidades de hidratos de carbono",
            "description": "Alterar as unidades de hidratos de carbono",
            "date": "2 Nov 2023",
            "duration": "0:46",
            "category": "dana",
            "videoUrl": "https://youtu.be/cCdBBbBY9MY",
            "views": 1900
        },
        {
            "id": 56,
            "title": "Calibrar o sensor",
            "description": "Calibrar o sensor",
            "date": "20 May 2025",
            "duration": "2:24",
            "category": "ypso",
            "videoUrl": "https://youtu.be/9sRFDE1kiGk",
            "views": 3000
        },
        {
            "id": 57,
            "title": "Calibrar o sensor",
            "description": "Calibrar o sensor",
            "date": "19 Sep 2023",
            "duration": "2:09",
            "category": "dana",
            "videoUrl": "https://youtu.be/uA0qNL2LZx4",
            "views": 2900
        },
        {
            "id": 58,
            "title": "Ajustar os tamanhos de refeição predefinidos",
            "description": "Ajustar os tamanhos de refeição predefinidos",
            "date": "11 Aug 2026",
            "duration": "0:37",
            "category": "ypso",
            "videoUrl": "https://youtu.be/rUm9Y-m07Aw",
            "views": 4000
        },
        {
            "id": 59,
            "title": "Ajustar os tamanhos de refeição predefinidos",
            "description": "Ajustar os tamanhos de refeição predefinidos",
            "date": "11 Aug 2026",
            "duration": "0:37",
            "category": "dana",
            "videoUrl": "https://youtu.be/t-xGygiAvbA",
            "views": 3900
        },
        {
            "id": 60,
            "title": "Gerir a atividade física",
            "description": "Gerir a atividade física",
            "date": "25 Apr 2025",
            "duration": "6:15",
            "category": "ypso",
            "videoUrl": "https://youtu.be/XmGnI19zCCg",
            "views": 34000
        },
        {
            "id": 61,
            "title": "Gerir a atividade física",
            "description": "Gerir a atividade física",
            "date": "25 Apr 2025",
            "duration": "6:15",
            "category": "dana",
            "videoUrl": "https://youtu.be/XmGnI19zCCg",
            "views": 33900
        },
        {
            "id": 62,
            "title": "Como é que o CamAPS FX gere a administração de insulina?",
            "description": "Como é que o CamAPS FX gere a administração de insulina?",
            "date": "11 Aug 2026",
            "duration": "3:30",
            "category": "ypso",
            "videoUrl": "https://youtu.be/NazbZLST-u8",
            "views": 35000
        },
        {
            "id": 63,
            "title": "Como é que o CamAPS FX gere a administração de insulina?",
            "description": "Como é que o CamAPS FX gere a administração de insulina?",
            "date": "11 Aug 2026",
            "duration": "3:28",
            "category": "dana",
            "videoUrl": "https://youtu.be/4ZSrJ-jwLoE",
            "views": 34900
        },
        {
            "id": 64,
            "title": "Como é que o CamAPS FX aprende?",
            "description": "Como é que o CamAPS FX aprende?",
            "date": "11 Aug 2026",
            "duration": "4:23",
            "category": "ypso",
            "videoUrl": "https://youtu.be/BGevr-RJjoc",
            "views": 36000
        },
        {
            "id": 65,
            "title": "Como é que o CamAPS FX aprende?",
            "description": "Como é que o CamAPS FX aprende?",
            "date": "11 Aug 2026",
            "duration": "4:23",
            "category": "dana",
            "videoUrl": "https://youtu.be/9U0W6kin1Z4",
            "views": 35900
        },
        {
            "id": 66,
            "title": "CamAPS Liberty",
            "description": "CamAPS Liberty",
            "date": "6 Aug 2026",
            "duration": "3:15",
            "category": "ypso",
            "videoUrl": "https://youtu.be/xzrWcu_oYo0",
            "views": 0
        },
        {
            "id": 67,
            "title": "CamAPS Liberty",
            "description": "CamAPS Liberty",
            "date": "6 Aug 2026",
            "duration": "3:15",
            "category": "dana",
            "videoUrl": "https://youtu.be/2Al-lQbEnxM",
            "views": 0
        }

    ]
};

